import React from 'react';
import { Phone, Mail, MapPin } from 'lucide-react';
import content from '../../translations/content.json';
import './style.css';

const ContactPage = () => {
  const { contactPage } = content;

  return (
    <div className="contact-page-container">
      <div className="contact-header">
        <h1>
          <Mail className="inline-block w-8 h-8 mr-3 -mt-1" />
          {contactPage.header.title}
        </h1>
        <p>{contactPage.header.subtitle}</p>
      </div>
      <div className="contact-content-wrapper">
        <div className="contact-form-container">
          <form>
            <div className="form-group">
              <label htmlFor="name">{contactPage.form.name}</label>
              <input type="text" id="name" name="name" placeholder={`Your ${contactPage.form.name}`} />
            </div>
            <div className="form-group">
              <label htmlFor="email">{contactPage.form.email}</label>
              <input type="email" id="email" name="email" placeholder={`Your ${contactPage.form.email}`} />
            </div>
            <div className="form-group">
              <label htmlFor="message">{contactPage.form.message}</label>
              <textarea id="message" name="message" rows="6" placeholder={`Your ${contactPage.form.message}`}></textarea>
            </div>
            <button type="submit" className="btn-submit">{contactPage.form.submit}</button>
          </form>
        </div>
        <div className="contact-info-container">
          <div className="contact-image-placeholder">
          </div>
          <div className="contact-details">
            <h2>{contactPage.office.title}</h2>
            <div className="info-item">
              <MapPin className="info-icon" />
              <div>
                <strong>Present Address:</strong>
                <p>{contactPage.office.presentAddress}</p>
              </div>
            </div>
            <div className="info-item">
              <MapPin className="info-icon" />
              <div>
                <strong>Registered Address:</strong>
                <p>{contactPage.office.registeredAddress}</p>
              </div>
            </div>
            <div className="info-item">
              <Mail className="info-icon" />
              <p>{contactPage.office.email}</p>
            </div>
            <div className="info-item">
              <Phone className="info-icon" />
              <p>{contactPage.office.phone}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;
